import { render } from "./IconItemCategoryAppliances.vue?vue&type=template&id=563c73c4"
import script from "./IconItemCategoryAppliances.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryAppliances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__